import api from "./client";

export async function listKnivesPaged({ status, page, limit, diameter, platesCount, moldType } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", String(status));
  if (page !== undefined && page !== null) params.set("page", String(page));
  if (limit !== undefined && limit !== null) params.set("limit", String(limit));
  if (diameter) params.set("diameter", String(diameter));
  if (platesCount) params.set("plates_count", String(platesCount));
  if (moldType) params.set("mold_type", String(moldType));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const res = await api.get(`/knives${qs}`);
  return res.data.data;
}

export async function createKnife(payload) {
  const res = await api.post("/knives", payload);
  return res.data.data;
}

export async function updateKnife(id, payload) {
  const res = await api.put(`/knives/${id}`, payload);
  return res.data.data;
}

export async function deleteKnife(id) {
  const res = await api.delete(`/knives/${id}`);
  return res.data.data;
}

export async function getKnifeVariantOptions() {
  const res = await api.get("/knives/variant-options");
  return res.data.data;
}
